@if (!completeness()?.completed) {
    @if (isOwner()) {
        <aside class="relative select-none">
            <button
                (click)="open.set(!open())"
                class="box lg:px-5 lg:py-2 lg:min-w-[14rem] size-16 lg:h-14 lg:flex items-center justify-between z-50"
            >
                <p class="text-white lg:block hidden">센터 완성도</p>
                <p class="text-white min-w-max">
                    {{ completenessPercent() }} %
                </p>
            </button>

            @if (open()) {
                <div
                    animate.enter="fade-in"
                    animate.leave="fade-out"
                    class="w-[20rem] lg:min-w-[30rem] absolute rounded-2xl shadow-lg bg-gray-50 flex flex-col gap-6 p-6 bottom-[calc(100%+16px)] right-0"
                >
                    <div class="flex items-start justify-between">
                        <div class="flex flex-col gap-1">
                            <p class="text-gray-800 font-medium text-xl">
                                센터 완성도
                            </p>
                            <p class="text-sm text-gray-400">
                                단계별로 센터를 완성해보세요!
                            </p>
                        </div>
                        <app-icon
                            (click)="open.set(false)"
                            name="mdi:close"
                            class="text-zinc-400 cursor-pointer"
                        />
                    </div>

                    <div class="flex gap-2 items-center w-full">
                        <p class="text-primary text-lg">
                            {{ completenessPercent() }}%
                        </p>
                        <div
                            class="flex gap-1 items-center w-full rounded-full overflow-hidden"
                        >
                            @for (i of completeds(); track $index) {
                                <div class="bg-primary flex-1 h-3"></div>
                            }
                            @for (i of incompleteds(); track $index) {
                                <div class="bg-zinc-200 flex-1 h-3"></div>
                            }
                        </div>
                    </div>

                    <div class="flex flex-col gap-3">
                        <app-create-service-completeness />
                        <app-create-child-completeness />
                        <app-child-with-service-completeness />
                        <app-create-schedule-completeness />
                    </div>

                    @if (!completeness()?.completed) {
                        @if (
                            completeness()?.childWithService &&
                            completeness()?.createChild &&
                            completeness()?.createSchedule &&
                            completeness()?.createService
                        ) {
                            <div class="flex gap-3 items-center">
                                <button
                                    (click)="reStartTutorial()"
                                    appTooltip="등록한 내용이 모두 삭제 되며 튜토리얼을 다시 시작합니다."
                                    class="button"
                                >
                                    <app-icon
                                        name="solar:restart-linear"
                                        class="!size-[18px] text-gray-400"
                                    />
                                    <p class="text-sm text-gray-600">
                                        다시하기
                                    </p>
                                </button>
                                <button
                                    class="button"
                                    (click)="reset()"
                                    appTooltip="튜토리얼로 등록한 내용이 모두 삭제 됩니다."
                                >
                                    <app-icon
                                        name="solar:trash-bin-minimalistic-2-linear"
                                        class="!size-[18px] text-gray-400"
                                    />
                                    <p class="text-sm text-gray-600">초기화</p>
                                </button>
                                <button
                                    (click)="confirm()"
                                    appTooltip="튜토리얼로 등록한 내용이 유지된채 활동할 수 있습니다."
                                    class="button"
                                >
                                    <app-icon
                                        name="solar:download-minimalistic-linear"
                                        class="!size-[18px] text-gray-400"
                                    />
                                    <p class="text-sm text-gray-600">저장</p>
                                </button>
                            </div>
                            <button
                                (click)="openModal()"
                                class="cursor-pointer select-none"
                            >
                                <app-hint>초기화/저장 안내 ></app-hint>
                            </button>
                        }
                    }
                </div>
            }
        </aside>
    }
}
